import firebase from "firebase";

var config = {
    apiKey: "AIzaSyCR7EbLes5krvqNE-hufy4cYXqE9gGjYck",
    authDomain: "portfolio-336c8.firebaseapp.com",
    databaseURL: "https://portfolio-336c8.firebaseio.com",
    projectId: "portfolio-336c8",
    storageBucket: "portfolio-336c8.appspot.com",
    messagingSenderId: "1086007117277"
};

firebase.initializeApp(config);

let storageRef = firebase.storage();

export {
    storageRef
};


// WEBPACK FOOTER //
// ./src/firebase.js